var $c63231bcc300d0df$exports = {};
$c63231bcc300d0df$exports = {
    "Clear search": `Po\u{10D}isti iskanje`
};


export {$c63231bcc300d0df$exports as default};
//# sourceMappingURL=sl-SI.module.js.map
